import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Subscription } from 'rxjs';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { ErrorHandleService } from 'src/app/shared/services/error-handle/error-handle.service';
import { FiltroBuscaService } from '../service/filtro-busca-service/filtro-busca.service';

@Component({
  selector: 'app-filtro-cadastrada-em',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, DropdownToggleDirective],
  templateUrl: './filtro-cadastrada-em.component.html',
  styleUrls: ['./filtro-cadastrada-em.component.scss'],
})
export class FiltroCadastradaEmComponent {
  filtroCadastradaEm: Array<any> = [];
  selecionado: any = null;
  private isInitializing = true;

  @Input() idModuloSelecionado: number;
  @Output() cadastradaEmChange = new EventEmitter<any>();
  @Input() cadastradaEmSelecionado: any = null;
  @Input() disabled: boolean = false;
  @Input() iconeLaranja: boolean = false;

  private readonly _errorHandleService = inject(ErrorHandleService);
  private subscription = new Subscription();

  constructor(private readonly _filtroBuscaService: FiltroBuscaService) {}

  ngOnInit(): void {
    this.isInitializing = true;
    this.filtrarCadastradaEm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes['cadastradaEmSelecionado'] &&
      changes['cadastradaEmSelecionado'].currentValue !== undefined
    ) {
      const val = changes['cadastradaEmSelecionado'].currentValue;
      this.selecionado = val && typeof val === 'object' ? val.value : val;
    }
  }
  filtrarCadastradaEm() {
    this.subscription.add(
      this._filtroBuscaService.buscarCadastradaEm().subscribe({
        next: (res) => {
          if (res.success) {
            this.filtroCadastradaEm = res.data;
            if (
              this.cadastradaEmSelecionado !== null &&
              this.cadastradaEmSelecionado !== undefined
            ) {
              const val = this.cadastradaEmSelecionado;
              this.selecionado =
                val && typeof val === 'object' ? val.value : val;
            } else {
              const defaultItem = this.filtroCadastradaEm.find(
                (item: any) => item.value === 0 || item.value === '0',
              );
              this.selecionado =
                defaultItem?.value ?? this.filtroCadastradaEm[0]?.value;
            }

            this.isInitializing = false;
          } else {
            console.error('Error fetching Cadastrada Em filter:', res.message);
          }
        },
        error: (err) => {
          console.error('API call failed for Cadastrada Em filter:', err);
        },
      }),
    );
  }

  onRadioChange(valor: any) {
    this.selecionado = valor;
    this.emitirSelecionado();
  }

  emitirSelecionado() {
    const selecionadoObj = this.filtroCadastradaEm.find(
      (item: any) => item.value == this.selecionado,
    );
    if (selecionadoObj) {
      this.cadastradaEmChange.emit(selecionadoObj);
    }
  }
}
